import script from "./CustomDashboardSliderView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardSliderView.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardSliderView.vue?vue&type=style&index=0&id=16f954bc&lang=scss&scoped=true"
import "./CustomDashboardSliderView.vue?vue&type=style&index=1&id=16f954bc&lang=scss"
import "./CustomDashboardSliderView.vue?vue&type=style&index=2&id=16f954bc&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f954bc"]])

export default __exports__